import { createStyles } from 'antd-style'

import { EDITOR_CONTENT_WIDTH_CSS_VAR } from '../../hooks/useTraceEditorContentSize/constants'

export const useBaseStyles = createStyles(({ token }) => ({
  ltr: {
    textAlign: 'left'
  },
  rtl: {
    textAlign: 'right'
  },
  paragraph: {
    position: 'relative',
    margin: 0
  },
  quote: {
    position: 'relative',
    paddingInlineStart: '1em',
    marginBlock: token.marginSM,
    color: token.colorTextTertiary,
    ['&::before']: {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: 4,
      borderRadius: token.borderRadiusXS,
      backgroundColor: '#e2e6ed'
    }
  },
  h1: {
    marginBlockEnd: '0.5em',
    fontSize: token.fontSizeHeading2,
    fontWeight: token.fontWeightStrong
  },
  h2: {
    marginBlockEnd: '0.5em',
    fontSize: token.fontSizeHeading3,
    fontWeight: token.fontWeightStrong
  },
  h3: {
    marginBlockEnd: '0.5em',
    fontSize: token.fontSizeHeading4,
    fontWeight: token.fontWeightStrong
  },
  h4: {
    marginBlockEnd: '0.5em',
    fontSize: token.fontSizeHeading5,
    fontWeight: token.fontWeightStrong
  },
  textBase: {},
  textBold: {
    fontWeight: token.fontWeightStrong
  },
  textItalic: {
    fontStyle: 'italic'
  },
  textUnderline: {
    textDecoration: 'underline'
  },
  textStrikethrough: {
    textDecoration: 'line-through'
  },
  textUnderlineStrikethrough: {
    textDecoration: 'underline line-through'
  },
  textSubscript: {
    verticalAlign: 'sub',
    fontSize: '0.8em'
  },
  textSuperscript: {
    verticalAlign: 'super',
    fontSize: '0.8em'
  },
  link: {
    color: token.colorLink,
    textDecoration: 'none',
    cursor: 'pointer',
    ['&:hover']: {
      color: token.colorLink,
      backgroundColor: token.colorPrimaryBgHover
    },
    ['& img']: {
      marginInlineEnd: 2,
      verticalAlign: 'text-bottom'
    }
  },
  image: {
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'bottom',
    fontSize: 0,
    lineHeight: 0
  },
  attachment: {
    display: 'inline-block'
  },
  emoji: {
    cursor: 'pointer',
    ['&:hover']: {
      backgroundColor: token.colorPrimaryBgHover
    }
  },
  filler: {
    display: 'inline',
    minWidth: 2,
    textIndent: 0,
    verticalAlign: 'baseline',
    fontSize: token.fontSize
  },
  tableWrapper: {
    ['--lexical-table-border-color']: token.colorBorder,
    ['--lexical-table-selected-bg-color']: token.colorPrimaryBg,
    ['--lexical-table-marked-bg-color']: token.colorErrorBg,
    position: 'relative',
    paddingBlockStart: token.paddingMD,
    paddingInlineStart: token.paddingMD,
    maxWidth: `var(${EDITOR_CONTENT_WIDTH_CSS_VAR})`,
    overflowX: 'auto'
  },
  /**
   * @deprecated 弃用内置的，让 TableWrapper 处理滚动
   */
  tableScrollableWrapper: {
    maxWidth: `var(${EDITOR_CONTENT_WIDTH_CSS_VAR})`,
    overflowX: 'auto'
  },
  tableController: {
    position: 'relative'
  },
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    overflow: 'scroll',
    tableLayout: 'fixed',
    width: 'fit-content'
  },
  tableSelected: {
    outline: `1px solid ${token.colorPrimaryActive}`
  },
  tableCell: {
    position: 'relative',
    paddingBlock: token.paddingXXS,
    paddingInline: token.paddingXXS,
    verticalAlign: 'top',
    textAlign: 'start',
    fontWeight: 'normal',
    outline: 'none',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'var(--lexical-table-border-color)'
  },
  tableCellHeader: {
    textAlign: 'start'
  },
  tableCellSelected: {
    opacity: 0.7,
    backgroundColor: 'var(--lexical-table-selected-bg-color)'
  },
  // marked 样式需要放在 selected 样式之后，否则会被 selected 样式覆盖
  tableCellMarked: {
    opacity: 0.7,
    backgroundColor: 'var(--lexical-table-marked-bg-color)'
  },
  ol1: {
    margin: 0,
    padding: 0,
    listStyleType: 'decimal',
    listStylePosition: 'inside'
  },
  ol2: {
    margin: 0,
    padding: 0,
    listStyleType: 'lower-alpha',
    listStylePosition: 'inside'
  },
  ol3: {
    margin: 0,
    padding: 0,
    listStyleType: 'lower-roman',
    listStylePosition: 'inside'
  },
  ul: {
    margin: 0,
    padding: 0,
    listStylePosition: 'inside'
  },
  listItem: {
    margin: '0 1em'
  },
  listItemNested: {
    listStyleType: 'none',
    ['&:before,&:after']: {
      display: 'none'
    }
  },
  embedBlock: {
    userSelect: 'none'
  },
  embedBlockFocus: {
    outline: `2px solid ${token.colorPrimaryActive}`
  }
}))
